import Api from '../http.service';

/**
 *
 * @param {Object} payload
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 * @param {Object} payload.data
 * @param {String} payload.data.filter
 * @param {Object} payload.data.sort
 * @param {String} payload.data.sort.key
 * @param {String} payload.data.sort.value
 */
export const getDraft = ({
  pageNumber,
  itemPerPage,
  data = { filter: '{}', sort: { key: 'createdAt', value: 'desc' } },
}) =>
  Api.GET({
    url: `tour/draft?page=${pageNumber - 1}&size=${itemPerPage}&where=${
      data.filter
    }&sort=${data.sort.key}&order=${data.sort.value}`,
  });

/**
 *
 * @param {Object} payload
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 * @param {Object} payload.data
 * @param {String} payload.data.filter
 * @param {Object} payload.data.sort
 * @param {String} payload.data.sort.key
 * @param {String} payload.data.sort.value
 */

export const getAll = ({ pageNumber, itemPerPage, data }) =>
  Api.GET({
    url: `tour/all?page=${pageNumber - 1}&size=${itemPerPage}&where=${
      data.filter
    }&sort=${data.sort.key}&order=${data.sort.value}`,
  });

/**
 *
 * @param {Object} payload
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 * @param {Object} payload.data
 * @param {String} payload.data.filter
 * @param {Object} payload.data.sort
 * @param {String} payload.data.sort.key
 * @param {String} payload.data.sort.value
 */
export const getPendings = ({ pageNumber, itemPerPage, data }) =>
  Api.GET({
    url: `tour/pending?page=${pageNumber - 1}&size=${itemPerPage}&where=${
      data.filter
    }&sort=${data.sort.key}&order=${data.sort.value}`,
  });

/**
 *
 * @param {Object} payload
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 * @param {Object} payload.data
 * @param {String} payload.data.filter
 * @param {Object} payload.data.sort
 * @param {String} payload.data.sort.key
 * @param {String} payload.data.sort.value
 */
export const getReviewed = ({ pageNumber, itemPerPage, data }) =>
  Api.GET({
    url: `tour/reviews?page=${pageNumber - 1}&size=${itemPerPage}&where=${
      data.filter
    }&sort=${data.sort.key}&order=${data.sort.value}`,
  });

/**
 *
 * @param {Object} payload
 * @param {string} payload.operatorId
 * @param {Object} payload.data
 * @param {Array} payload.data.images
 * @param {boolean} payload.data.isActive
 * @param {string} payload.data.registerDate
 * @param {number} payload.data.duration
 * @param {string} payload.data.moneyUnit
 * @param {string} payload.data.bookingDeadLine
 * @param {Array} payload.data.cancelingRules
 * @param {Object} payload.data.limitations
 * @param {string} payload.data.limitations.en
 * @param {string} payload.data.limitations.fa
 * @param {Object} payload.data.necessities
 * @param {string} payload.data.necessities.en
 * @param {string} payload.data.necessities.fa
 * @param {Object} payload.data.description
 * @param {string} payload.data.description.en
 * @param {string} payload.data.description.fa
 * @param {Object} payload.data.tourInfo
 * @param {Array} payload.data.tourTransport
 * @param {Array} payload.data.residency
 * @param {Array} payload.data.facilities
 * @param {object} payload.data.status
 * @param {number} payload.data.status.operatorId
 * @param {object} payload.data.status.description
 * @param {string} payload.data.status.description.en
 * @param {string} payload.data.status.description.fa
 */
export const insertDraft = ({ data }) => {
  const { status, ...res } = data;
  return Api.POST({
    url: '/tour',
    data: {
      ...res,
      status: {
        ...status,
        statusType: {
          _id: '65239273b327754268abb3cc',
          name: {
            en: 'draft',
            fa: 'پیشنویس',
          },
          type: 'tourstatustype',
          code: '1',
          isActive: true,
          totalCount: 5,
          description: {
            en: 'draft tour status type',
            fa: 'تور پیشنویس',
          },
        },
      },
    },
  });
};

/**
 *
 * @param {Object} payload
 * @param {string} payload.operatorId
 * @param {Object} payload.data
 * @param {string} payload.data._id
 * @param {Array} payload.data.images
 * @param {boolean} payload.data.isActive
 * @param {string} payload.data.registerDate
 * @param {number} payload.data.duration
 * @param {string} payload.data.moneyUnit
 * @param {string} payload.data.bookingDeadLine
 * @param {Array} payload.data.cancelingRules
 * @param {Object} payload.data.limitations
 * @param {string} payload.data.limitations.en
 * @param {string} payload.data.limitations.fa
 * @param {Object} payload.data.necessities
 * @param {string} payload.data.necessities.en
 * @param {string} payload.data.necessities.fa
 * @param {Object} payload.data.description
 * @param {string} payload.data.description.en
 * @param {string} payload.data.description.fa
 * @param {Object} payload.data.tourInfo
 * @param {Array} payload.data.tourTransport
 * @param {Array} payload.data.residency
 * @param {Array} payload.data.facilities
 * @param {object} payload.data.status
 * @param {number} payload.data.status.operatorId
 * @param {object} payload.data.status.description
 * @param {string} payload.data.status.description.en
 * @param {string} payload.data.status.description.fa
 */
export const updateDraft = ({ data }) => {
  const { _id, status, ...res } = data;
  return Api.PUT({
    url: '/tour',
    data: {
      _id,
      ...res,
      status: {
        ...status,
        statusType: {
          _id: '65239273b327754268abb3cc',
          name: {
            en: 'draft',
            fa: 'پیشنویس',
          },
          type: 'tourstatustype',
          code: '1',
          isActive: true,
          totalCount: 5,
          description: {
            en: 'draft tour status type',
            fa: 'تور پیشنویس',
          },
        },
      },
    },
  });
};

/**
 *
 * @param {Object} payload
 * @param {string} payload._id
 */
export const removeDraft = ({ _id }) =>
  Api.DELETE({
    url: '/tour',
    data: {
      _id,
    },
  });

/**
 *
 * @param {Object} payload
 * @param {Array} payload.images
 * @param {boolean} payload.isActive
 * @param {string} payload.registerDate
 * @param {number} payload.duration
 * @param {string} payload.moneyUnit
 * @param {string} payload.bookingDeadLine
 * @param {Array} payload.cancelingRules
 * @param {Object} payload.limitations
 * @param {string} payload.limitations.en
 * @param {string} payload.limitations.fa
 * @param {Object} payload.necessities
 * @param {string} payload.necessities.en
 * @param {string} payload.necessities.fa
 * @param {Object} payload.description
 * @param {string} payload.description.en
 * @param {string} payload.description.fa
 * @param {Object} payload.tourInfo
 * @param {Array} payload.tourTransport
 * @param {Array} payload.residency
 * @param {Array} payload.facilities
 * @param {object} payload.status
 * @param {number} payload.status.operatorId
 * @param {object} payload.status.description
 * @param {string} payload.status.description.en
 * @param {string} payload.status.description.fa
 */
export const insert = ({ data }) => {
  const { status, ...res } = data;
  return Api.POST({
    url: '/tour',
    data: {
      ...res,
      necessities: {
        en: '',
        fa: '',
      },
      cancelingRules: [],
      moneyUnit: 'IRR',
      registerDate: new Date().toISOString().split('T')[0],
      status: {
        ...status,
        statusType: {
          _id: '65239f0cb327754268abb3cd',
          name: {
            en: 'new',
            fa: 'جدید',
          },
          description: {
            en: 'new tour status type',
            fa: 'تور جدید',
          },
          type: 'tourStatusType',
          code: '2',
        },
      },
    },
  });
};

/**
 *
 * @param {Object} payload
 * @param {string} payload._id
 * @param {Array} payload.images
 * @param {boolean} payload.isActive
 * @param {string} payload.registerDate
 * @param {number} payload.duration
 * @param {string} payload.moneyUnit
 * @param {string} payload.bookingDeadLine
 * @param {Array} payload.cancelingRules
 * @param {Object} payload.limitations
 * @param {string} payload.limitations.en
 * @param {string} payload.limitations.fa
 * @param {Object} payload.necessities
 * @param {string} payload.necessities.en
 * @param {string} payload.necessities.fa
 * @param {Object} payload.description
 * @param {string} payload.description.en
 * @param {string} payload.description.fa
 * @param {Object} payload.tourInfo
 * @param {Array} payload.tourTransport
 * @param {Array} payload.residency
 * @param {Array} payload.facilities
 * @param {object} payload.status
 * @param {number} payload.status.operatorId
 * @param {object} payload.status.description
 * @param {string} payload.status.description.en
 * @param {string} payload.status.description.fa
 */
export const update = ({ data }) => {
  const { status, ...res } = data;
  return Api.PUT({
    url: '/tour',
    data: {
      ...res,
      necessities: {
        en: '',
        fa: '',
      },
      cancelingRules: [],
      moneyUnit: 'IRR',
      registerDate: new Date().toISOString().split('T')[0],
      status: {
        ...status,
        statusType: {
          _id: '65239f0cb327754268abb3cd',
          name: {
            en: 'new',
            fa: 'جدید',
          },
          description: {
            en: 'new tour status type',
            fa: 'تور جدید',
          },
          type: 'tourStatusType',
          code: '2',
        },
      },
    },
  });
};

/**
 *
 * @param {Object} payload
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 * @param {Object} payload.data
 * @param {String} payload.data.filter
 * @param {Object} payload.data.sort
 * @param {String} payload.data.sort.key
 * @param {String} payload.data.sort.value
 */
export const getAllAcives = ({ pageNumber, itemPerPage, data }) =>
  Api.GET({ url: `tour/active?page=${pageNumber - 1}&size=${itemPerPage}` });

/**
 *
 * @param {Object} payload
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 * @param {Object} payload.data
 * @param {String} payload.data.filter
 * @param {Object} payload.data.sort
 * @param {String} payload.data.sort.key
 * @param {String} payload.data.sort.value
 */
export const getAllExpired = ({ pageNumber, itemPerPage, data }) =>
  Api.GET({ url: `tour/expire?page=${pageNumber - 1}&size=${itemPerPage}` });

/**
 *
 * @param {Object} payload
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 * @param {Object} payload.data
 * @param {String} payload.data.filter
 * @param {Object} payload.data.sort
 * @param {String} payload.data.sort.key
 * @param {String} payload.data.sort.value
 */
export const getCustomerAcives = ({ pageNumber, itemPerPage, data }) =>
  Api.GET({
    url: `tour/customer/all/?page=${pageNumber - 1}&size=${itemPerPage}`,
  });
/**
 *
 * @param {Object} payload
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 * @param {Object} payload.data
 * @param {String} payload.data.filter
 * @param {Object} payload.data.sort
 * @param {String} payload.data.sort.key
 * @param {String} payload.data.sort.value
 */
export const getCustomerById = (id) =>
  Api.GET({
    url: `tour/customer/${id}`,
  });
